import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import getProducts from "../Services/productService";




// Initial state
const initialState = {
  value: [],
  status: 'idle', // idle | loading | succeeded | failed
  error: null
};

// Thunk to fetch orders
export const fetchProduct = createAsyncThunk('product/fetchProduct', async () => {
  const response = await getProducts();
  return response.products;
});

export const productSlice = createSlice({
  name: "product",
  initialState,
  reducers: {
    update: (state, action) => {
      state.value = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProduct.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchProduct.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.value = action.payload;
      })
      .addCase(fetchProduct.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  }
});

// Action creators are generated for each case reducer function
export const { update } = productSlice.actions;

export default productSlice.reducer;
